import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { containerTypesLoad } from 'portal/store/wasteReferenceData/containerTypes/actions'

export const useContainerTypesLoader = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(containerTypesLoad())
  }, [dispatch])

  const { loading, error, items } = useSelector((state: any) => {
    return state.containerTypes
  })

  return {
    loading,
    error,
    items
  }
}
